import WomanPng from "../../assets/imgs/persons/ratingWoman.png";

export default function RatingWoman({
	width = "100%",
	height = "auto",
	backgroundFill,
	circleFill,
}) {
	return (
		<div>
			<svg
				width={width}
				height={height}
				viewBox="0 0 1265 423"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				style={{ display: "block", maxWidth: "100%" }}
			>
				<path
					d="M1.81435 0H1262.77C1262.77 0 1262.58 64.0229 1262.77 136.964C1262.97 212.516 1262.38 297.669 1192.92 333.092C1056.41 402.714 1102.85 198.625 894.987 180.939C687.123 163.253 702.554 330.588 607.25 348.274C511.947 365.96 451.117 182.3 355.813 180.939C260.509 179.579 127.077 326.507 42.6609 302.019C-5.60361 288.018 -1.51896 191.299 1.82812 111.027C1.82812 50.9608 1.81435 0 1.81435 0Z"
					fill={backgroundFill}
					fill-opacity="0.66"
				/>
				<path
					d="M1.73695 0H1263.59C1263.59 0 1263.59 2.73027 1263.59 95.5593C1264.77 120.617 1263.59 152.575 1263.59 192.484C1263.59 380.63 551.486 45.3685 218.753 192.149C7.62583 285.284 0.00207031 181.563 1.36689 94.1941C1.75852 45.9331 1.73695 0 1.73695 0Z"
					fill={backgroundFill}
					fill-opacity="0.65"
				/>
				<g filter="url(#filter0_d_760_2636)">
					<ellipse
						cx="645.033"
						cy="212.961"
						rx="200.464"
						ry="202.04"
						fill={circleFill}
					/>
				</g>
				<rect
					x="452.648"
					y="5.56128"
					width="384.766"
					height="384.766"
					fill="url(#pattern0_760_2636)"
				/>
				<defs>
					<filter
						id="filter0_d_760_2636"
						x="440.568"
						y="10.921"
						width="408.928"
						height="412.079"
						filterUnits="userSpaceOnUse"
						color-interpolation-filters="sRGB"
					>
						<feFlood flood-opacity="0" result="BackgroundImageFix" />
						<feColorMatrix
							in="SourceAlpha"
							type="matrix"
							values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
							result="hardAlpha"
						/>
						<feOffset dy="4" />
						<feGaussianBlur stdDeviation="2" />
						<feComposite in2="hardAlpha" operator="out" />
						<feColorMatrix
							type="matrix"
							values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
						/>
						<feBlend
							mode="normal"
							in2="BackgroundImageFix"
							result="effect1_dropShadow_760_2636"
						/>
						<feBlend
							mode="normal"
							in="SourceGraphic"
							in2="effect1_dropShadow_760_2636"
							result="shape"
						/>
					</filter>
					<pattern
						id="pattern0_760_2636"
						patternContentUnits="objectBoundingBox"
						width="1"
						height="1"
					>
						<use xlinkHref="#image0_760_2636" transform="scale(0.000976563)" />
					</pattern>
					<image
						id="image0_760_2636"
						width="1024"
						height="1024"
						preserveAspectRatio="none"
						href={WomanPng}
					/>
				</defs>
			</svg>
		</div>
	);
}
